"use client";

import Link from "next/link";
import { useEffect } from "react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[error.tsx]", {
      url: typeof window !== "undefined" ? window.location.href : undefined,
      digest: error.digest,
      message: error.message,
      stack: error.stack,
      error,
    });
  }, [error]);
  let errorTitle = "Hoppsan - något gick fel!";
  let errorDescr =
    "Vi har för närvarande tekniska problem och arbetar aktivt med att lösa dem så snabbt som möjligt. Vänligen försök igen om en stund.";
  let buttonText = "Tillbaka till startsidan";
  if (error.message === "fetch failed") {
    errorTitle = "Ingen internetanslutning!";
    errorDescr =
      "Det verkar som att du saknar internetuppkoppling. Kontrollera din anslutning och försök igen.";
    buttonText = "Testa igen";
  }
  return (
    <div className="container py-8 space-y-8">
      <div className="prose ">
        <h1>{errorTitle}</h1>
        <p>{errorDescr}</p>
      </div>

      <Link className="btn" href="/">
        {buttonText}
      </Link>
    </div>
  );
}
